import '../chart_view.js.coffee';# Added by Script 
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.EmotionsChartView extends Monitoring.Views.Charts.ChartView
  template: JST["backbone/templates/monitoring/charts/generic_chart"]
  className: 'processing item pie-chart'
  url: "/monitoring/api/charts/emotion"

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @_settings = @options.settings
    @container = @options.container
    @title = I18n.t('monitoring.dashboard.charts.emotion.title')

  render: ->
    @$el.html(@template({
      title: @title
    }))
    @

  afterAppend: ->
    data = _.extend({}, @searchQuery.toJSON(), {'first_dimension': 'content_id', 'second_dimension': 'tags'})
    @ajaxCall(@url, data, (response) =>
      @chart = new Highcharts.Chart(@$el.find('.chart')[0], @_getChartOptions(response))
      @$el.removeClass('processing')
    )
    super

  _getChartOptions: (values) ->
    chart:
      polar: true
      type: 'area'

    title:
      text: null

    xAxis:
      categories: _.collect(values, (value) -> I18n.t("monitoring.dashboard.charts.emotion.#{value['name']}").titleize())
      tickmarkPlacement: 'on'
      lineWidth: 0

    plotOptions:
      area:
        color: "#cab5e6"
        lineColor: "#ad94ce"
        events:
          click: (e) => @_previewSearch(e.point.series.chart.options.series[e.point.index].name) # is there a better way to access its name?

    yAxis:
      gridLineInterpolation: 'polygon'
      lineWidth: 0
      min: 0

    pane:
      size: '100%'

    tooltip:
      positioner: (labelWidth, labelHeight, point) ->
        chart = this.chart
        pointX = if (point.plotX + labelWidth > chart.plotWidth) then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
        x = if pointX > 0 then pointX else 0
        y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
        return { x: x , y: y }
      pointFormat: 'Total: {point.y}'

    legend:
      enabled: false

    series: _.map(values, (value) -> {name: value['name'], data: _.pluck(values, 'amount')})

  _previewSearch: (emotionName) ->
    @createPreviewDashboard(@getNewQuery(emotionName))

  getNewQuery: (emotionName) ->
    query = @searchQuery.deepCopy()
    emotion = emotionName
    query.setEmotion(emotion)
